import {
  RiHome5Line,
  RiMenuLine,
  RiDownloadCloud2Line,
  RiStore2Line,
} from "react-icons/ri";
import { BiBookOpen } from "react-icons/bi";
import { Link, useLocation } from "react-router-dom";
import { Tooltip } from "@mui/material";
import { RiMegaphoneLine, RiFileList3Line } from "react-icons/ri";
import { useAuth } from "../../../hooks/AuthContext";
import { useOnboard } from "../../../hooks/OnboardContext";
import { i18n } from "../../../localization/i18n";
import { customerSituations } from "../../../utils/constants";
import { MenuButton, MenuItemContainer } from "../styles";

interface MenuListProps {
  extendedMode: boolean;
  setExtendedMode?: (val: boolean) => void;
}

export const FixiterMenuList = ({ extendedMode }: MenuListProps) => {
  const { user } = useAuth();
  const { customerFixiter } = useOnboard();
  const location = useLocation();

  const tooltipProps = {
    tooltip: {
      sx: {
        backgroundColor: "var(--dark-gray)",
        color: "var(--white)",
        fontSize: "14px",
        fontWeight: "500",
        padding: "8px 14px",
        borderRadius: "6px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"
      }
    },
    arrow: {
      sx: {
        color: "var(--dark-gray)"
      }
    }
  };

  return (
    <>
      <MenuItemContainer>
        <Link
          to={
            customerFixiter?.situation === customerSituations.active
              ? "/fixiter/dashboard"
              : "/fixiter/dashboard"
          }
        >
          <Tooltip 
            title={extendedMode ? "" : `${i18n.t("sidebar.home") || "Início"}`} 
            placement="right" 
            arrow 
            disableHoverListener={extendedMode}
            componentsProps={tooltipProps}
          >
            <span style={{ display: 'block' }}>
              <MenuButton
                extendedMode={extendedMode}
                isActive={location.pathname.includes("/fixiter/dashboard")}
                disabled={
                  customerFixiter?.situation !== customerSituations.active &&
                  customerFixiter?.situation !== customerSituations.payment_pending
                }
              >
                <div className="content">
                  <RiHome5Line size={24} />
                  <span>{`${i18n.t("sidebar.home") || "Início"}`}</span>
                </div>
              </MenuButton>
            </span>
          </Tooltip>
        </Link>
      </MenuItemContainer>

      <MenuItemContainer>
        <Link
          to={
            customerFixiter?.situation === customerSituations.active
              ? "/orders"
              : "/fixiter/dashboard"
          }
        >
          <Tooltip 
            title={extendedMode ? "" : `${i18n.t("sidebar.requests")}`} 
            placement="right" 
            arrow 
            disableHoverListener={extendedMode}
            componentsProps={tooltipProps}
          >
            <span style={{ display: 'block' }}>
              <MenuButton
                extendedMode={extendedMode}
                isActive={location.pathname.includes("/orders")}
                disabled={customerFixiter?.situation !== customerSituations.active}
              >
                <div className="content">
                  <RiMenuLine size={24} />
                  <span>{`${i18n.t("sidebar.requests")}`}</span>
                </div>
              </MenuButton>
            </span>
          </Tooltip>
        </Link>
      </MenuItemContainer>

      <MenuItemContainer>
        <Link
          to={
            customerFixiter?.situation === customerSituations.active
              ? "/solutions"
              : "/fixiter/dashboard"
          }
        >
          <Tooltip 
            title={extendedMode ? "" : `${i18n.t("sidebar.solutions")}`} 
            placement="right" 
            arrow 
            disableHoverListener={extendedMode}
            componentsProps={tooltipProps}
          >
            <span style={{ display: 'block' }}>
              <MenuButton
                extendedMode={extendedMode}
                isActive={location.pathname.includes("/solutions")}
                disabled={customerFixiter?.situation !== customerSituations.active}
              >
                <div className="content">
                  <RiDownloadCloud2Line size={24} />
                  <span>{`${i18n.t("sidebar.solutions")}`}</span>
                </div>
              </MenuButton>
            </span>
          </Tooltip>
        </Link>
      </MenuItemContainer>

      <MenuItemContainer>
        {customerFixiter?.situation === customerSituations.active &&
        user.store_domain ? (
          <a
            href={user.store_domain}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <Tooltip 
              title={extendedMode ? "" : `${i18n.t("sidebar.store") || "Loja"}`} 
              placement="right" 
              arrow 
              disableHoverListener={extendedMode}
              componentsProps={tooltipProps}
            >
              <span style={{ display: 'block' }}>
                <MenuButton extendedMode={extendedMode}>
                  <div className="content">
                    <RiStore2Line size={24} />
                    <span>{`${i18n.t("sidebar.store") || "Loja"}`}</span>
                  </div>
                </MenuButton>
              </span>
            </Tooltip>
          </a>
        ) : (
          <Tooltip 
            title={extendedMode ? "" : `${i18n.t("sidebar.store") || "Loja"}`} 
            placement="right" 
            arrow 
            disableHoverListener={extendedMode}
            componentsProps={tooltipProps}
          >
            <span style={{ display: 'block' }}>
              <MenuButton
                extendedMode={extendedMode}
                disabled={true}
              >
                <div className="content">
                  <RiStore2Line size={24} />
                  <span>{`${i18n.t("sidebar.store") || "Loja"}`}</span>
                </div>
              </MenuButton>
            </span>
          </Tooltip>
        )}
      </MenuItemContainer>

      <MenuItemContainer>
        <Link
          to={
            customerFixiter?.situation === customerSituations.active
              ? "/fixiter/courses"
              : "/fixiter/dashboard"
          }
        >
          <Tooltip 
            title={extendedMode ? "" : `${i18n.t("sidebar.courses")}`} 
            placement="right" 
            arrow 
            disableHoverListener={extendedMode}
            componentsProps={tooltipProps}
          >
            <span style={{ display: 'block' }}>
              <MenuButton
                extendedMode={extendedMode}
                isActive={location.pathname.includes("/fixiter/courses")}
                disabled={
                  customerFixiter?.situation !== customerSituations.active &&
                  customerFixiter?.situation !== customerSituations.payment_pending
                }
              >
                <div className="content">
                  <BiBookOpen size={24} />
                  <span>{`${i18n.t("sidebar.courses")}`}</span>
                </div>
              </MenuButton>
            </span>
          </Tooltip>
        </Link>
      </MenuItemContainer>

      <MenuItemContainer>
        {customerFixiter?.situation === customerSituations.active ? (
          <a
            href="https://drive.google.com/drive/folders/1w4X3B8F8g1-g12G-22B-FwWkXbK3YkI8?usp=sharing"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <Tooltip 
              title={extendedMode ? "" : `${i18n.t("sidebar.marketing") || "Marketing"}`} 
              placement="right" 
              arrow 
              disableHoverListener={extendedMode}
              componentsProps={tooltipProps}
            >
              <span style={{ display: 'block' }}>
                <MenuButton extendedMode={extendedMode}>
                  <div className="content">
                    <RiMegaphoneLine size={24} />
                    <span>{`${i18n.t("sidebar.marketing") || "Marketing"}`}</span>
                  </div>
                </MenuButton>
              </span>
            </Tooltip>
          </a>
        ) : (
          <Tooltip 
            title={extendedMode ? "" : `${i18n.t("sidebar.marketing") || "Marketing"}`} 
            placement="right" 
            arrow 
            disableHoverListener={extendedMode}
            componentsProps={tooltipProps}
          >
            <span style={{ display: 'block' }}>
              <MenuButton
                extendedMode={extendedMode}
                disabled={true}
              >
                <div className="content">
                  <RiMegaphoneLine size={24} />
                  <span>{`${i18n.t("sidebar.marketing") || "Marketing"}`}</span>
                </div>
              </MenuButton>
            </span>
          </Tooltip>
        )}
      </MenuItemContainer>

      <MenuItemContainer>
        <Link
          to={
            customerFixiter?.situation === customerSituations.active
              ? "/fixiter/certificate"
              : "/fixiter/dashboard"
          }
        >
          <Tooltip 
            title={extendedMode ? "" : `${i18n.t("sidebar.certificate") || "Certificado"}`} 
            placement="right" 
            arrow 
            disableHoverListener={extendedMode}
            componentsProps={tooltipProps}
          >
            <span style={{ display: 'block' }}>
              <MenuButton
                extendedMode={extendedMode}
                isActive={location.pathname.includes("/fixiter/certificate")}
                disabled={
                  customerFixiter?.situation !== customerSituations.active &&
                  customerFixiter?.situation !== customerSituations.payment_pending
                }
              >
                <div className="content">
                  <RiFileList3Line size={24} />
                  <span>{`${i18n.t("sidebar.certificate") || "Certificado"}`}</span>
                </div>
              </MenuButton>
            </span>
          </Tooltip>
        </Link>
      </MenuItemContainer>
    </>
  );
};

